import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TableCell, TableRow, Chip } from '@mui/material'

import {
  TableMenuButtonComponent,
  TableMenuComponent,
  TableMenuOptions,
} from '@/views/components'
import { getButtonText } from '@/utils'
import { BonusLibraryColumnProps } from '@/state/bonus-engine/models'

type Props = {
  row: BonusLibraryColumnProps
  hasAction: boolean
  handleEditBonus: (bonusId: string) => void
  handleDuplicateBonus: (bonusId: string) => void
  handleDeleteBonus: (
    anchorPosition: {
      top: number
      left: number
    },
    bonusId: string,
  ) => void
}

export const BonusesRowComponent = ({
  row,
  hasAction,
  handleEditBonus,
  handleDuplicateBonus,
  handleDeleteBonus,
}: Props) => {
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const canDelete = hasAction && !row.isActive

  const canEdit = hasAction

  const handleClickButton = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    type: TableMenuOptions,
  ) => {
    const anchorPosition = {
      top: anchorEl?.getBoundingClientRect().top || event.clientY,
      left: anchorEl?.getBoundingClientRect().left || event.clientX,
    }
    type === 'delete' && handleDeleteBonus(anchorPosition, row._id.toString())
    type === 'edit' && handleEditBonus(row._id.toString())
    type === 'duplicate' && handleDuplicateBonus(row._id.toString())

    setAnchorEl(null)
  }

  return (
    <>
      <TableRow hover>
        <TableCell>
          <Chip
            variant="filled"
            size="medium"
            label={t(`${row.isActive ? 'labels.active' : 'labels.inactive'}`)}
            className={`${row.isActive ? 'green' : 'red'}`}
            sx={{ width: '100%' }}
          />
        </TableCell>
        <TableCell>{row.createdAt}</TableCell>
        <TableCell>
          {canEdit
            ? getButtonText(row.name, () => handleEditBonus(row._id.toString()))
            : row.name}
        </TableCell>
        <TableCell>{row.code}</TableCell>
        <TableCell>{row.triggerText}</TableCell>
        <TableCell>{row.type}</TableCell>
        {(canDelete || canEdit) && (
          <TableMenuButtonComponent setAnchorEl={setAnchorEl} />
        )}
      </TableRow>
      <TableMenuComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClickButton={handleClickButton}
        canDelete={canDelete}
        canEdit={canEdit}
        canDuplicate={canEdit}
      />
    </>
  )
}
